import { Controller } from '@hotwired/stimulus';

const AMOUNT_PATTERN = /^\d+([.,]\d{1,2})?$/;
const INCOME_FORM_ID = 'esaf-income-sign-form';
const SPACES = /[\s ]/g;
const PANE_GESTURES = ['touchstart', 'touchmove', 'touchend'];

export default class extends Controller {
  static targets = [
    'uploadForm',
    'amountPreview',
    'amountInput',
    'editAmountButton',
    'amountField',
    'amountError',
    'paneDragBlocker',
  ];

  stopPaneGesture = (event) => event.stopPropagation();

  paneDragBlockerTargetConnected(element) {
    PANE_GESTURES.forEach((type) => element.addEventListener(type, this.stopPaneGesture));
  }

  paneDragBlockerTargetDisconnected(element) {
    PANE_GESTURES.forEach((type) => element.removeEventListener(type, this.stopPaneGesture));
  }

  editAmount() {
    if (this.hasAmountPreviewTarget) this.amountPreviewTarget.classList.add('hidden');
    if (this.hasAmountInputTarget) this.amountInputTarget.classList.remove('hidden');
    if (this.hasEditAmountButtonTarget) this.editAmountButtonTarget.classList.add('hidden');
  }

  normalizeAmount() {
    if (!this.hasAmountFieldTarget) return;

    this.amountFieldTarget.value = this.amountFieldTarget.value.replace(SPACES, '');
    if (this.validAmount()) this.hideAmountError();
  }

  validAmount() {
    if (!this.hasAmountFieldTarget) return true;

    return AMOUNT_PATTERN.test(this.amountFieldTarget.value.replace(SPACES, ''));
  }

  showAmountError() {
    if (this.hasAmountErrorTarget) this.amountErrorTarget.classList.remove('hidden');
    if (this.hasAmountFieldTarget) this.amountFieldTarget.focus();
  }

  hideAmountError() {
    if (this.hasAmountErrorTarget) this.amountErrorTarget.classList.add('hidden');
  }

  connect() {
    this.onFileChange = () => this.refreshSubmitState();
    this.element.addEventListener('change', this.onFileChange);

    this.incomeForm = document.getElementById(INCOME_FORM_ID);
    this.onIncomeSubmit = (event) => {
      this.normalizeAmount();
      if (this.validAmount()) return;

      event.preventDefault();
      event.stopPropagation();
      this.showAmountError();
    };
    if (this.incomeForm) this.incomeForm.addEventListener('submit', this.onIncomeSubmit);

    const fileBoxWrapper = this.element.querySelector('[data-dropzone-target="fileBoxWrapper"]');
    if (fileBoxWrapper) {
      this.fileBoxObserver = new MutationObserver(() => this.refreshSubmitState());
      this.fileBoxObserver.observe(fileBoxWrapper, { childList: true });
      this.refreshSubmitState();
    }
  }

  disconnect() {
    this.element.removeEventListener('change', this.onFileChange);
    if (this.incomeForm) this.incomeForm.removeEventListener('submit', this.onIncomeSubmit);
    if (this.fileBoxObserver) this.fileBoxObserver.disconnect();
  }

  refreshSubmitState() {
    const input = this.hasUploadFormTarget && this.uploadFormTarget.querySelector('input[type="file"]');
    if (!input) return;

    const hasFile = input.files && input.files.length > 0;
    const button = this.submitButton();
    if (button) button.disabled = !hasFile;
  }

  submitButton() {
    return document.getElementById('esaf-upload-submit');
  }

  upload(event) {
    event.preventDefault();

    const button = this.submitButton();
    if (button) {
      button.disabled = true;
      button.textContent = 'Wysyłanie...';
    }

    fetch(this.uploadFormTarget.action, {
      method: 'POST',
      body: new FormData(this.uploadFormTarget),
      credentials: 'same-origin',
      headers: {
        Accept: 'text/javascript',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
      },
    })
      .then((response) => response.text())
      .then((js) => window.jQuery.globalEval(js));
  }
}
